(() => {
  if (window.__coinyWelcomeV4) return;
  window.__coinyWelcomeV4 = true;
  const controllers = new WeakMap();
  const invitations = new WeakMap();
  const invitationKey = 'coiny-welcome-invitation-v1';
  const campaignKey = 'coiny-campaign-session-v1';
  const campaignParameters = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_id', 'utm_content', 'utm_term'];
  let invitationConsumed = false;
  let privacyRequested = false;

  function sessionGet(key) {
    try { return window.sessionStorage.getItem(key); } catch (_) { return null; }
  }

  function sessionSet(key, value) {
    try { window.sessionStorage.setItem(key, value); } catch (_) { /* Storage can be unavailable in private browsing. */ }
  }

  function consumeInvitation() {
    invitationConsumed = true;
    sessionSet(invitationKey, 'seen');
  }

  // Measurement preparation only: never send these values, add customer tags,
  // or treat them as lead/sales attribution. No click IDs, referrer or form data.
  function rememberCampaign() {
    const privacy = window.Shopify?.customerPrivacy;
    if (typeof privacy?.analyticsProcessingAllowed !== 'function' || typeof privacy?.marketingAllowed !== 'function') return;
    let allowed = false;
    try { allowed = privacy.analyticsProcessingAllowed() === true && privacy.marketingAllowed() === true; } catch (_) { return; }
    if (!allowed) {
      try { window.sessionStorage.removeItem(campaignKey); } catch (_) { /* No storage access. */ }
      return;
    }
    if (sessionGet(campaignKey)) return;
    const parameters = new URLSearchParams(window.location.search);
    const utm = {};
    campaignParameters.forEach((key) => {
      const value = parameters.get(key)?.trim();
      if (value && /^[a-zA-Z0-9][a-zA-Z0-9 _.-]{0,99}$/.test(value)) utm[key] = value;
    });
    if (Object.keys(utm).length) sessionSet(campaignKey, JSON.stringify({ version: 1, utm }));
  }

  function initializeCampaignMemory() {
    const parameters = new URLSearchParams(window.location.search);
    if (!sessionGet(campaignKey) && !campaignParameters.some((key) => parameters.has(key))) return;
    if (window.Shopify?.customerPrivacy) { rememberCampaign(); return; }
    if (privacyRequested || typeof window.Shopify?.loadFeatures !== 'function') return;
    privacyRequested = true;
    try {
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], (error) => {
        if (!error) rememberCampaign();
      });
    } catch (_) { /* Signup remains available when the optional API cannot load. */ }
  }

  function visible(element) {
    if (!element || element.hidden || element.getAttribute('aria-hidden') === 'true') return false;
    const style = getComputedStyle(element);
    if (style.display === 'none' || style.visibility === 'hidden' || Number(style.opacity) === 0) return false;
    const rect = element.getBoundingClientRect();
    return rect.width > 0 && rect.height > 0 && rect.top < innerHeight && rect.bottom > 0;
  }

  function inviteAfterEngagement(root) {
    if (invitations.has(root) || window.Shopify?.designMode || /(?:^|\/)(cart|checkouts?)(?:\/|$)/i.test(window.location.pathname)) return;
    if (invitationConsumed || sessionGet(invitationKey) || root.querySelector('[data-cm-welcome-success], [data-cm-welcome-error]')) return;
    let elapsed = false;
    let invitation = null;
    let queued = false;
    let stopped = false;
    // Keep purchase, consent and support controls clear. The invitation never
    // opens a modal, moves focus, locks scrolling or submits the signup form.
    const obstacleSelector = 'dialog[open], cart-drawer.active, cart-notification.active, #cm-mobile-menu:not([hidden]), [data-cm-v5-buy]:not([hidden]), #shopify-pc__banner, .shopify-pc__banner, #onetrust-banner-sdk, #CybotCookiebotDialog, [data-cookie-banner], .cc-window, .osano-cm-window, #shopify-chat, #ShopifyChat, shopify-chat, #gorgias-chat-container, #intercom-container, .intercom-lightweight-app, iframe[title*="chat" i], iframe[id*="chat" i]';

    function purchaseControlInSpace() {
      const width = window.innerWidth;
      const left = width <= 800 ? 12 : 24;
      const space = invitation?.getBoundingClientRect() || { left, right: left + Math.min(380, width - left * 2), top: innerHeight - 220, bottom: innerHeight };
      return Array.from(document.querySelectorAll('.cm-add-form button[type="submit"], product-form button[name="add"], button[name="checkout"], .shopify-payment-button')).some((control) => {
        if (!visible(control)) return false;
        const rect = control.getBoundingClientRect();
        return rect.left < space.right && rect.right > space.left && rect.top < space.bottom && rect.bottom > space.top;
      });
    }

    function blocked() {
      const active = document.activeElement;
      return document.visibilityState === 'hidden' || !root.isConnected ||
        Boolean(document.querySelector('[data-cm-welcome-success], [data-cm-welcome-error]')) ||
        Boolean(active?.matches('input, textarea, select, [contenteditable="true"]')) ||
        Boolean(window.visualViewport && innerHeight - window.visualViewport.height > 150) ||
        purchaseControlInSpace() ||
        Array.from(document.querySelectorAll(obstacleSelector)).some(visible) ||
        visible(root.querySelector('[data-cm-welcome-panel]'));
    }

    function cleanup() {
      if (stopped) return;
      stopped = true;
      clearTimeout(timer);
      observer.disconnect();
      window.removeEventListener('scroll', schedule);
      window.removeEventListener('resize', schedule);
      document.removeEventListener('focusin', schedule);
      document.removeEventListener('focusout', schedule);
      document.removeEventListener('visibilitychange', schedule);
      document.removeEventListener('click', checkSignupClick);
      window.visualViewport?.removeEventListener('resize', schedule);
      invitation?.remove();
    }

    function checkSignupClick(event) {
      if (event.target.closest('[data-cm-welcome-trigger]')) { consumeInvitation(); cleanup(); }
    }

    function evaluate() {
      queued = false;
      if (stopped) return;
      if (invitation) { if (blocked()) cleanup(); return; }
      if (invitationConsumed || sessionGet(invitationKey)) { cleanup(); return; }
      const scrollThreshold = Math.min(240, Math.max(120, innerHeight * .3));
      if (!elapsed || window.scrollY < scrollThreshold || blocked()) return;
      invitation = document.createElement('aside');
      invitation.className = 'cm-welcome-invitation';
      invitation.setAttribute('aria-label', 'Optional Coiny Minds email invitation');
      invitation.innerHTML = '<div><p class="cm-welcome-invitation-title">A little help for their big future.</p><a class="cm-welcome-invitation-link" href="#cm-welcome" data-cm-welcome-trigger></a><p class="cm-welcome-invitation-note">Money-play ideas. Product news. Join if you’d like.</p></div><button class="cm-welcome-invitation-dismiss" type="button" aria-label="Dismiss email invitation">\u00d7</button>';
      invitation.querySelector('a').textContent = root.dataset.offerEnabled === 'true' ? 'Get 10% off your first order' : 'Join the Coiny Minds email list';
      invitation.querySelector('button').addEventListener('click', () => {
        const returnFocus = invitation.contains(document.activeElement);
        cleanup();
        if (returnFocus) document.querySelector('[data-cm-welcome-trigger]')?.focus({ preventScroll: true });
      });
      document.body.append(invitation);
      consumeInvitation();
      enhanceTriggers();
    }

    function schedule() {
      if (queued || stopped) return;
      queued = true;
      requestAnimationFrame(evaluate);
    }

    const observer = new MutationObserver((records) => {
      if (records.some((record) => !invitation?.contains(record.target))) schedule();
    });
    observer.observe(document.body, { subtree: true, childList: true, attributes: true, attributeFilter: ['open', 'class', 'hidden', 'aria-hidden', 'style'] });
    const timer = setTimeout(() => { elapsed = true; schedule(); }, 12000);
    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule, { passive: true });
    document.addEventListener('focusin', schedule);
    document.addEventListener('focusout', schedule);
    document.addEventListener('visibilitychange', schedule);
    document.addEventListener('click', checkSignupClick);
    window.visualViewport?.addEventListener('resize', schedule, { passive: true });
    invitations.set(root, { cleanup });
  }

  function initialize(root) {
    if (!root || controllers.has(root)) return controllers.get(root);
    const home = root.querySelector('[data-cm-welcome-home]');
    const panel = root.querySelector('[data-cm-welcome-panel]');
    const dialog = root.querySelector('[data-cm-welcome-dialog]');
    const content = root.querySelector('[data-cm-welcome-dialog-content]');
    if (!home || !panel || !dialog || !content) return null;
    let opener = null;
    let priorOverflow = null;

    function restore() {
      if (panel.parentElement !== home) home.append(panel);
      home.classList.remove('is-in-dialog');
      if (priorOverflow !== null) document.body.style.overflow = priorOverflow;
      priorOverflow = null;
      const returnFocus = opener?.isConnected && visible(opener) ? opener : document.querySelector('[data-cm-welcome-trigger]');
      returnFocus?.focus({ preventScroll: true });
      opener = null;
    }

    function close() {
      if (dialog.open) dialog.close();
    }

    function open(trigger) {
      const tags = panel.querySelector('[data-cm-welcome-tags]');
      const plannerNote = panel.querySelector('[data-cm-planner-note]');
      const plannerInterest = trigger.hasAttribute('data-cm-welcome-planner');
      if (tags) tags.value = plannerInterest ? 'newsletter,coiny-welcome,coiny-planner-interest' : 'newsletter,coiny-welcome';
      if (plannerNote) plannerNote.hidden = !plannerInterest;
      if (typeof dialog.showModal !== 'function') return false;
      if (dialog.open) return true;
      opener = trigger;
      content.append(panel);
      home.classList.add('is-in-dialog');
      priorOverflow = document.body.style.overflow;
      try {
        dialog.showModal();
        document.body.style.overflow = 'hidden';
      } catch (_) {
        restore();
        return false;
      }
      const initialFocus = panel.querySelector('[data-cm-welcome-success], [data-cm-welcome-error], input[type="email"]');
      initialFocus?.focus({ preventScroll: true });
      return true;
    }

    dialog.addEventListener('close', restore);
    dialog.querySelector('[data-cm-welcome-close]')?.addEventListener('click', close);
    dialog.addEventListener('click', (event) => {
      if (event.target !== dialog) return;
      const rect = dialog.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) close();
    });
    // Native <dialog> handles the focus boundary and Escape. Form submission
    // stays native; no JavaScript success state or email claim is created.
    const serverStatus = panel.querySelector('[data-cm-welcome-error], [data-cm-welcome-success]');
    if (serverStatus) serverStatus.focus();
    const controller = { open, close };
    controllers.set(root, controller);
    return controller;
  }

  function enhanceTriggers() {
    const root = document.querySelector('[data-cm-welcome]');
    const dialog = root?.querySelector('[data-cm-welcome-dialog]');
    if (!dialog || typeof dialog.showModal !== 'function') return;
    document.querySelectorAll('[data-cm-welcome-trigger]').forEach((trigger) => {
      trigger.setAttribute('aria-haspopup', 'dialog');
      trigger.setAttribute('aria-controls', dialog.id);
    });
  }

  document.addEventListener('click', (event) => {
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const trigger = event.target.closest('[data-cm-welcome-trigger]');
    if (!trigger) return;
    const root = document.querySelector('[data-cm-welcome]');
    const controller = initialize(root);
    if (controller?.open(trigger)) event.preventDefault();
  });
  document.querySelectorAll('[data-cm-welcome]').forEach(initialize);
  enhanceTriggers();
  document.querySelectorAll('[data-cm-welcome]').forEach(inviteAfterEngagement);
  initializeCampaignMemory();
  document.addEventListener('visitorConsentCollected', rememberCampaign);
  window.addEventListener('load', initializeCampaignMemory, { once: true });
  document.addEventListener('shopify:section:load', () => {
    document.querySelectorAll('[data-cm-welcome]').forEach(initialize);
    enhanceTriggers();
    document.querySelectorAll('[data-cm-welcome]').forEach(inviteAfterEngagement);
  });
  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll('[data-cm-welcome]').forEach((root) => {
      controllers.get(root)?.close();
      invitations.get(root)?.cleanup();
    });
  });
})();
